export const STATUS_MAP = {
  START: 'start',
  WAIT: 'wait',
  RECOGNIZED: 'recognized',
  UNIDENTIFICATION: 'unidentification'
};
